<script setup lang="ts">
interface DesktopProductCardLayoutProps {
  printMode?: boolean;
}

const props = defineProps<DesktopProductCardLayoutProps>();
</script>

<template>
  <div
    class="desktop-product-card-layout"
    :class="{
      'print-mode': props.printMode,
    }"
  >
    <div class="left-section">
      <slot name="left-section" />
      <slot name="left-section-tag" />
    </div>
    <div class="right-section">
      <div class="content">
        <slot name="content" />
      </div>
      <div class="footer">
        <slot name="footer" />
      </div>
    </div>
    <slot name="tag" />
  </div>
</template>

<style scoped lang="scss">
.desktop-product-card-layout {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));

  &.is-experiment {
    grid-template-columns: 3fr 5fr;
  }

  border-radius: var(--border-radius-8);
  border: 1px solid var(--color-neutral-30);
  background-color: var(--color-white);
  overflow: hidden;
  width: 100%;
  position: relative;

  padding: var(--spacing-16);
  gap: var(--spacing-16);

  &:not(.print-mode) {
    @include on-hover {
      cursor: pointer;
      transition: var(--transition-short);
      background-color: var(--color-neutral-20);
    }
  }

  .left-section {
    height: 100%;
    width: 100%;
    min-width: 0;
    aspect-ratio: 5 / 4;
    border-radius: var(--border-radius-8);
    overflow: hidden;
    position: relative;
  }

  .right-section {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .content {
      border-bottom: unset;
      border-bottom-left-radius: unset;
      flex: 1;
    }

    .footer {
      border: unset;
      border-bottom-left-radius: var(--border-radius-8);
      border-top-right-radius: unset;
    }
  }
}
</style>
